import { ConfigurableColumns } from '@/components/ConfigurableColumns';
import { CopiableIdDataGridField } from '@/components/CopiableIdField';
import { GenericDateFunctionField } from '@/components/GenericDateFunctionField';
import { DateField } from 'react-admin';

export const columns: ConfigurableColumns[] = [
  {
    label: 'Note Id',
    omit: true,
    source: 'id',
    sortable: true,
    exportFn: (doc: any) => doc.id,
  },
  {
    label: 'Homework Date',
    source: 'createdAt',
    sortable: true,
    GridComponent: DateField,
    exportFn: (doc: any) => new Date(doc.createdAt).toISOString(),
  },
  {
    label: 'Note Time',
    source: 'createdAt',
    sortable: true,
    GridComponent: GenericDateFunctionField,
    gridComponentProps: { format: 'HH:mm:ss' },
    exportFn: false,
  },
  { label: 'Title', source: 'therapistTitle', omit: true },
  { label: 'First Name', source: 'therapistFirstName' },
  { label: 'Last Name', source: 'therapistLastName' },
  { label: 'Email', source: 'therapistEmail' },
  {
    label: 'Therapist Id',
    source: 'therapistId',
    exportFn: record => record.therapistId,
    GridComponent: CopiableIdDataGridField,
    gridComponentProps: {
      targetNavigationResource: 'therapists',
      referenceField: '_id',
      filter: ['therapistId', 'therapistId'],
      targetNavigationFilters: {
        isHiddenTestAccount: 'visible',
      },
    },
  },
  { label: 'Files Count', source: 'filesCount' },
  { label: 'Media Type', source: 'mediaType' },
  {
    label: 'Source Word Count',
    source: 'wordCount.narrative',
  },
  { label: 'App Version', source: 'appVersion' },
  { label: 'Status', source: 'status' },
  { label: 'Deleted At', source: 'deletedAt', omit: true },
];
